import { StyleSheet, ScrollView, SafeAreaView } from "react-native";
import React, { useEffect, useState } from "react";
import RecommendedDiscountsRail from "../../components/RecommendedDiscountsRail";
import HighlightedDiscountsRail from "../../components/HighlightedDiscountsRail";
import LatestNewsRail from "../../components/LatestNewsRail";
import Header from "../../components/Header";
import UserInformationCard from "../../components/UserInformationCard";
import OptionsCard from "../../components/OptionsCard";
import Announcements from "../../components/Announcements";
import useApi from "../../hooks/useAPI";
import { useQuery } from "react-query";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import { setDiscounts } from "../../store/slices/discountsSlice";
import DiscountsPerCategoryCard from "../../components/DiscountsPerCategoryCard/DiscountsPerCategoryCard";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { showMessage } from "react-native-flash-message";
import { HomeScreenProps } from "./HomeStack";

const DISCOUNTS_STORAGE_KEY = "@discounts";
//const ANNOUNCEMENTS_STORAGE_KEY = "@announcements";

const Home = ({ navigation }: HomeScreenProps) => {
	const api = useApi();
	const dispatch = useAppDispatch();
	const discounts = useAppSelector(s => s.discounts);

	//const user = useAppSelector(s => s.auth.subUser!);

	const [allDiscounts, setAllDiscounts] = useState([]);
	const [highlightDiscountsIds, setHighlightDiscountsIds] = useState([]);
	const [highlightDiscounts, setHighlightDiscounts] = useState([]);

	const { isLoading: discountsLoading } = useQuery(
		"discounts",
		api.discounts.getDiscounts,

		{
			onSuccess: async res => {
				dispatch(setDiscounts(res.data));
				if (res.data)
					await AsyncStorage.setItem(
						DISCOUNTS_STORAGE_KEY,
						JSON.stringify(res.data)
					);
			},
			onError: async (e: any) => {
				const savedDiscounts = await AsyncStorage.getItem(
					DISCOUNTS_STORAGE_KEY
				);
				console.log("erro na getDiscounts");

				showMessage({
					type: "warning",
					message: "Failed to fetch discounts. Check your internet connection",
				});
				if (savedDiscounts) {
					dispatch(setDiscounts(JSON.parse(savedDiscounts)));
				}
			},
		}
	);

	const filteredDiscounts = discounts?.filter(
		d => d.bannerImageId?.length > 0 && d.popularity
	);

	// const { isLoading: servicesLoading } = useQuery(
	// 	"services",
	// 	() => api.services.getAllDocuments(),

	// 	{
	// 		onSuccess: async res => {
	// 			setAllDiscounts(res.data);
	// 		},
	// 		onError: async (e: any) => {
	// 			console.log("erro na getAllDocuments");
	// 		},
	// 	}
	// );

	// const { isLoading: loadingHighlight } = useQuery(
	// 	"highlights",
	// 	() => api.services.getHighlightIds(),
	// 	{
	// 		onSuccess: async res => {
	// 			setHighlightDiscountsIds(res.data);
	// 		},
	// 		onError: async (e: any) => {
	// 			console.log("erro na getHighlightIds");
	// 		},
	// 	}
	// );

	// function getHighlightDiscounts() {
	// 	const inOrder = highlightDiscountsIds
	// 		.map(id => allDiscounts.find(discount => discount.id === id))
	// 		.filter(object => object !== undefined);

	// 	console.log({ inOrder });
	// 	setHighlightDiscounts(inOrder);
	// }

	// useEffect(() => {
	// 	if (
	// 		!servicesLoading &&
	// 		!loadingHighlight &&
	// 		allDiscounts.length > 0 &&
	// 		highlightDiscountsIds.length > 0
	// 	) {
	// 		getHighlightDiscounts();
	// 	}
	// }, [allDiscounts, highlightDiscountsIds]);

	return (
		<SafeAreaView>
			<Header />

			<ScrollView contentContainerStyle={styles.scrollView}>
				<UserInformationCard />
				<OptionsCard />

				<DiscountsPerCategoryCard title="Descontos por categoria" />
				<Announcements
					title={"Descontos populares"}
					announcements={filteredDiscounts}
					type="discounts"
					seeAllButton={true}
					loading={discountsLoading}
				/>

				<HighlightedDiscountsRail
					style={{ zIndex: 1 }}
					highlightDiscounts={highlightDiscounts}
					navigation={navigation}
				/>
				<RecommendedDiscountsRail />
				<LatestNewsRail />
			</ScrollView>
		</SafeAreaView>
	);
};

export default Home;

const styles = StyleSheet.create({
	scrollView: {
		paddingBottom: 140,
	},
});
